// extracted by mini-css-extract-plugin
module.exports = {"dragLayer":"styles_dragLayer__2gcX5"};